import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";
import _ from "lodash";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { ShelvesQuickFilters } from "@/pages/shelves/components/quick-filters";
import { useShelvesColumns } from "@/pages/shelves/hooks/use-columns";
import { IShelfData } from "@/types/shelf";

export const ShelvesList = () => {
  const columns = useShelvesColumns();

  const defaultQueryBy = "name";

  const table = useTable<IShelfData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
    },
    refineCoreProps: {
      meta: {
        defaultQueryBy: defaultQueryBy,
      },
      sorters: {
        permanent: [
          {
            field: "position",
            order: "asc",
          },
        ],
      },
      pagination: {
        pageSize: 25,
      },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="shelves" table={table}>
        <ShelvesQuickFilters table={table} />
      </DataTableActionBar>
      <DataTable table={table} />
    </ListView>
  );
};
